
/* injects from baggage-loader */
require('./style.styl');

import React from 'react'
import {connect} from 'react-redux'
import {closeModal} from 'redux/modules/ui/modal/actions'
import {cancelSubscription} from 'redux/modules/billing/actions'
import {getCurrentMerchant} from 'redux/modules/currentUser/selectors'
import formatDate from 'date-fns/format'
import Confirm from 'components/Confirm'

export default connect(state => {
  const {currentPeriodEnd} = getCurrentMerchant(state)
  const formattedDate = formatDate(new Date(currentPeriodEnd * 1000), 'MMMM D, YYYY')
  return {
    className: 'subscription-confirm',
    message: (
      <div>
        Your current subscription is active untill {formattedDate}.
        <br />
        Are you sure you want to cancel your subscription? Remember all the good times we had!
      </div>
    ),
    ok: 'Cancel subscription',
    okClassName: 'is-red',
    cancel: 'Close',
    cancelClassName: 'is-blue'
  }
}, (dispatch, {report}) => {
  const dispatchCloseModal = () => dispatch(closeModal())

  return {
    onOk: () => dispatch(cancelSubscription()).success(dispatchCloseModal).fail(dispatchCloseModal),
    onCancel: dispatchCloseModal
  }
})(Confirm)



// WEBPACK FOOTER //
// ./client/modals/CancelSubscriptionConfirm/index.js